
// import chooseWhat from './chooseWhat'
import chooseWhats from './chooseWhats'
// import chooseWhat2 from './chooseWhat2'
// import chooseWhat3 from './chooseWhat3'
import chooseWhat4 from './chooseSimpleWhat'
import chooseWorks from './chooseWorks'
import chooseExamRoom from './chooseExamRoom'
import chooseCampus from './chooseCampus'
import chooseOrgs from './chooseOrg'
import choosePosts from './choosePost'
import chooseMajor from './chooseMajor'

let choosePersonInstance

let chooseSimplePersonInstance

let choosePersonInstances

let chooseByLinkInstance

let chooseByLinkSingleInstance

let chooseWorksInstance

let chooseExamRoomInstance

let chooseCampusInstance

let chooseOrgInstance

let choosePostInstance

let chooseMajorInstance

window.choosePerson = function(configOrFn) {
  if (!choosePersonInstance) {
    choosePersonInstance = new Vue(chooseWhat)
    choosePersonInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(choosePersonInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      caption: "选择人员",
      multi: true,
      selected: [],
      confirm: function() {},
      left: [{
        caption: "按组织机构选择",
        nodeTransfer: "id",

        treeUrl: InterfacePrefix['platform'] + "/api/selectPeople/listTree",
        displayKey: "orgName",

        rightUrl: InterfacePrefix['platform'] + "/api/account/list",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn
    } else {
      Vue.util.extend(defaultConfig, configOrFn)
    }

    choosePersonInstance.config = defaultConfig
    choosePersonInstance.is_show = true
  }
}

window.chooseByLink = function(config) {
  if (!chooseByLinkInstance) {
    chooseByLinkInstance = new Vue(chooseWhat2)
    chooseByLinkInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseByLinkInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      caption: "选择人员",
      min: 1,
      selected: [],
      confirm: function() {},
      link: "",
      query: {
        conditionList: [],
        columnList: [{
          caption: "姓名",
          displayKey: "userName",
        }, {
          caption: "简称",
          displayKey: "shortName",
        }],
      },
      result: {
        getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
        conditionList: [],
        columnList: [{
          caption: "姓名",
          displayKey: "userName",
        }, {
          caption: "简称",
          displayKey: "shortName",
        }]
      }
    }

    if (Vue.util.isPlainObject(config)) {
      Vue.util.extend(defaultConfig, config)
    } else {
      throw new Error(`
    chooseByLink: 调用参数错误: 必须如下形式子集:
    chooseByLink({
      caption: "",
      multi: true,
      selected: [],
      confirm: function(){},
      link: "",
      query: {
        conditionList: [{
          label: "姓名",
          key: "userName",
        }],
        columnList: [{
          label: "姓名",
          key: "userName",
        }],
      },
      result: {
        conditionList: [],
        columnList: [],
      }
    })
    `)
    }

    chooseByLinkInstance.config = defaultConfig
    chooseByLinkInstance.is_show = true
  }
}

window.chooseByLinkSingle = function(config) {
  if (!chooseByLinkSingleInstance) {
    chooseByLinkSingleInstance = new Vue(chooseWhat3)
    chooseByLinkSingleInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseByLinkSingleInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      caption: "选择人员",
      confirm: function() {},
      link: "",
      query: {
        conditionList: [],
        columnList: [{
          caption: "姓名",
          displayKey: "userName",
        }, {
          caption: "简称",
          displayKey: "shortName",
        }],
      },
    }

    if (Vue.util.isPlainObject(config)) {
      Vue.util.extend(defaultConfig, config)
    } else {
      throw new Error(`
    chooseByLinkSingle: 调用参数错误: 必须如下形式子集:
    chooseByLinkSingle({
      caption: "",
      confirm: function(){},
      link: "",
      query: {
        conditionList: [{
          label: "姓名",
          key: "userName",
        }],
        columnList: [{
          label: "姓名",
          key: "userName",
        }],
      },
    })
    `)
    }

    chooseByLinkSingleInstance.config = defaultConfig
    chooseByLinkSingleInstance.is_show = true
  }
}

window.choosePersons = function(configOrFn) {
  if (!choosePersonInstances) {
    choosePersonInstances = new Vue(chooseWhats)
    choosePersonInstances.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(choosePersonInstances.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      orgCaption: "按组织机构选择 ",//org
      schoolCaption: "按学校选择 ",//school
      socialCaption: '按社交关系',//social
      initialParams:[],
      showtab:"",//为空默认显示三个，其他需要的类型以数组方式传['org','school','social']
      isEmptyFilter:false,//是否清空筛选条件，true：清空，false：不清空
      multi: true,
      selected: [],
      seletedData:[],
      noAuth:0,
      isShowMore:true,//按组织结构选择是否显示更多,
      selectNumLimit:null,//选择数量限制
      role: [{
        key: "T",
        value: "教师"
      },
        {
          key: "S",
          value: "学生"
        },
        {
          key: "P",
          value: "家长"
        },
      ],
      subject:[
        // {key:"4028e3935bf03438015bf0343a22000a",value:"语文"},
      ],
      confirm: function() {},
      left: [{
        caption: "按组织机构选择",
        nodeTransfer: "id",
        orgTreeUrl: '',
        socialTreeUrl: InterfacePrefix['platform'] + "/school",
        displayKey: "orgName",
        displayKeys: "groupName",
        rightUrl: InterfacePrefix['platform'] + "/api/selectPeople/query",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [
            {
              caption: "部门",
              displayKey: "orgName",
            },
            {
              caption: "学校",
              displayKey: "schoolName",
            },
            {
              caption: "身份证号/学籍号",
              displayKey: "idCard",
            }],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    choosePersonInstances.config = defaultConfig
    choosePersonInstances.is_show = true
  }
}

window.chooseSchool = function(configOrFn) {
  if (!chooseSimplePersonInstance) {
    console.log(!chooseSimplePersonInstance)
    chooseSimplePersonInstance = new Vue(chooseWhat4)
    chooseSimplePersonInstance.$mount();
    Vue.nextTick(function() {
      document.body.appendChild(chooseSimplePersonInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      orgcaption: "按组织机构选择 ",
      socialcaption: "按好友选择 ",
      showtab:"",
      multi: true,
      selected: [],
      seletedData:[],
      initialParams:[],
      role:[
        {key:"teacher",value:"教师"},
        {key:"student",value:"学生"},
        {key:"patriarch",value:"家长"},
      ],
      confirm: function() {},
      left: [{
        caption: "按组织机构选择",
        nodeTransfer: "id",
        orgTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/listTree",
        // socialTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/getGroups",
        displayKey: "orgName",
        displayKeys: "groupName",
        // rightUrl: InterfacePrefix['platform'] + "/api/selectPeople/query",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [
            // {
            //   caption: "姓名",
            //   displayKey: "userName",
            // }, {
            //   caption: "部门",
            //   displayKey: "orgName",
            // },

            {
              caption: "学校名称",
              displayKey: "value",
            },
            // {
            //   caption: "身份证号/学籍号/唯一标识",
            //   displayKey: "idCard",
            // }
          ],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    chooseSimplePersonInstance.config = defaultConfig
    chooseSimplePersonInstance.is_show = true
  }
}

window.chooseWorks = function(configOrFn) {
  if (!chooseWorksInstance) {
    chooseWorksInstance = new Vue(chooseWorks)
    chooseWorksInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseWorksInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      seletedData:[],
      confirm: function() {},
      columnList: [
        {
          caption: "作品名称",
          displayKey: "workTitle",
        }, {
          caption: "作者",
          displayKey: "creator",
        },
      ],
      actId:"",
      rightUrl: InterfacePrefix['resource'] +"activityWorks",
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    chooseWorksInstance.configs = defaultConfig
    chooseWorksInstance.is_show = true
  }
}

window.chooseExamRoom = function(configOrFn) {
  if (!chooseExamRoomInstance) {
    chooseExamRoomInstance = new Vue(chooseExamRoom)
    chooseExamRoomInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseExamRoomInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      orgcaption: "选择考场",
      caption:'选择考场',
      seletedData:[],
      examPlanId:"",
      campusId:"",
      gradeId:"",
      courseId:"",
      schoolId:'',
      firstLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthorityCampus",
      secondLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthorityGrade",
      thirdLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthoritySubject",
      // firstLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthoritySchool",
      // secondLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthorityCampus",
      // thirdLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthorityPhase",
      // fourthLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthorityGrade",
      confirm: function() {},
    }
    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    chooseExamRoomInstance.config = defaultConfig
    chooseExamRoomInstance.is_show = true
  }
}

window.chooseCampus = function(configOrFn) {
  if (!chooseCampusInstance) {
    chooseCampusInstance = new Vue(chooseCampus)
    chooseCampusInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseCampusInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      orgcaption: "按组织机构选择 ",
      seletedData:[],
      initialParams:[],
      showtab:"",
      firstLine:InterfacePrefix['platform'] +"/api/selectPeople/getAuthoritySchool",
      confirm: function() {},
      left: [{
        caption: "按组织机构选择",
        nodeTransfer: "id",
        orgTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/listTree",
        // socialTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/getGroups",
        displayKey: "orgName",
        displayKeys: "groupName",
        // rightUrl: InterfacePrefix['platform'] + "/api/selectPeople/query",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [
            {
              caption: "校区名字",
              displayKey: "value",
            },
            // {
            //   caption: "部门",
            //   displayKey: "orgName",
            // },

            // {
            //   caption: "校区地址",
            //   displayKey: "campusAddress",
            // },
            // {
            //   caption: "身份证号/学籍号/唯一标识",
            //   displayKey: "idCard",
            // }
          ],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }
    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    chooseCampusInstance.config = defaultConfig
    chooseCampusInstance.is_show = true
  }


}

window.chooseOrg = function(configOrFn) {
  if (!chooseOrgInstance) {
    chooseOrgInstance = new Vue(chooseOrgs)
    chooseOrgInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseOrgInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      orgcaption: "选组织机构 ",
      socialcaption: "按好友选择 ",
      showtab:"",
      multi: true,
      selected: [],
      seletedData:[],
      // role:[
      //   {key:"teacher",value:"教师"},
      //   {key:"student",value:"学生"},
      //   {key:"patriarch",value:"家长"},
      // ],
      confirm: function() {},
      left: [{
        caption: "选组织机构",
        nodeTransfer: "id",
        orgTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/listTree",
        displayKey: "orgName",
        displayKeys: "groupName",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [
            // {
            //   caption: "姓名",
            //   displayKey: "userName",
            // }, {
            //   caption: "部门",
            //   displayKey: "orgName",
            // },

            {
              caption: "机构名称",
              displayKey: "name",
            },
            // {
            //   caption: "身份证号/学籍号/唯一标识",
            //   displayKey: "idCard",
            // }
          ],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/by/ids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    chooseOrgInstance.config = defaultConfig
    chooseOrgInstance.is_show = true
  }
}

window.choosePost = function(configOrFn) {
  if (!choosePostInstance) {
    choosePostInstance = new Vue(choosePosts)
    choosePostInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(choosePostInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      orgcaption: "选岗位 ",
      socialcaption: "选岗位 ",
      showtab:"",
      multi: true,
      selected: [],
      seletedData:[],
      initialParams:[],
      role:[
        {key:"teacher",value:"教师"},
        {key:"student",value:"学生"},
        {key:"patriarch",value:"家长"},
      ],
      confirm: function() {},
      left: [{
        caption: "选岗位",
        nodeTransfer: "id",
        orgTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/listTree",
        // socialTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/getGroups",
        displayKey: "orgName",
        displayKeys: "groupName",
        // rightUrl: InterfacePrefix['platform'] + "/api/selectPeople/query",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [
            {
              caption: "编码",
              displayKey: "code",
            },
            {
              caption: "级别",
              displayKey: "level",
            },
            {
              caption: "机构",
              displayKey: "orgName",
            },
            {
              caption: "岗位名称",
              displayKey: "value",
            },
            // {
            //   caption: "身份证号/学籍号/唯一标识",
            //   displayKey: "idCard",
            // }
          ],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    choosePostInstance.config = defaultConfig
    choosePostInstance.is_show = true
  }
}

window.chooseMajor = function(configOrFn) {
  if (!chooseMajorInstance) {
    chooseMajorInstance = new Vue(chooseMajor)
    chooseMajorInstance.$mount()
    Vue.nextTick(function() {
      document.body.appendChild(chooseMajorInstance.$el)
      doShow()
    })
  } else {
    doShow()
  }

  function doShow() {
    let defaultConfig = {
      initialParams:[],
      isEmptyFilter:false,//是否清空筛选条件，true：清空，false：不清空
      multi: true,
      selected: [],
      seletedData:[],
      noAuth:0,
      role: [{
        key: "T",
        value: "教师"
      },
        {
          key: "S",
          value: "学生"
        },
        {
          key: "P",
          value: "家长"
        },
      ],
      confirm: function() {},
      left: [{
        caption: "",
        nodeTransfer: "id",
        orgTreeUrl: InterfacePrefix['platform'] + "/api/selectPeople/listTree",
        socialTreeUrl: InterfacePrefix['platform'] + "/school",
        displayKey: "orgName",
        displayKeys: "groupName",
        rightUrl: InterfacePrefix['platform'] + "/api/selectPeople/query",
      }],
      right: {
        waiting: {
          conditionList: [],
          columnList: [
            {
              caption: "部门",
              displayKey: "orgName",
            },
            {
              caption: "学校",
              displayKey: "schoolName",
            },
            {
              caption: "身份证号/学籍号",
              displayKey: "idCard",
            }],
        },
        selected: {
          getInfoUrl: InterfacePrefix['platform'] + "/api/account/byids",
          conditionList: [],
          columnList: [{
            caption: "姓名",
            displayKey: "userName",
          }, {
            caption: "简称",
            displayKey: "shortName",
          }]
        }
      },
    }

    if (typeof configOrFn === 'function') {
      defaultConfig.confirm = configOrFn;
    } else {
      Vue.util.extend(defaultConfig, configOrFn);
    }
    chooseMajorInstance.config = defaultConfig
    chooseMajorInstance.is_show = true
  }
}


// WEBPACK FOOTER //
// ./src/commonplugin/choose/index.js